import { createSlice } from "@reduxjs/toolkit";

const initialTabsState = {
    tabs: null,
    viewAll: false
}


const tabsSlice = createSlice({
    name: 'tabs',
    initialState: initialTabsState,
    reducers: {
        setTabs(state, data) {
            state.tabs = data.payload
        },
        setViewAll(state, data) {
            state.viewAll = data.payload
        }
    }
})

export const tabsActions = tabsSlice.actions

export default tabsSlice.reducer